import { IApiStore } from '@core/api/apiStore';
import { EndpointCallParams } from '@core/api/endpointCallParams';


type DeleteLicenseParams = {
    UnityId: string;
}

export const performDeleteLicense = async (api: IApiStore, params: EndpointCallParams<DeleteLicenseParams>) => {
    const { payload, ...rest } = params;
    const req = api
        .post('identity-app/api/v1/License/Delete', {
            ...rest,
            payload,
        })

    return req;
}
